export default "__VITE_ASSET__B6ANZ9rW__"